export default {
  '***': {
    '***': {
      displayFilters: null,
      staticFilters: [
        {
          label: 'Age',
          code: 'age',
          multi: true,
          options: [
            {
              label: '18-34',
              value: 1,
              selected: false
            },
            {
              label: '35-54',
              value: 2,
              selected: false
            },
            {
              label: '55+',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Gender',
          code: 'gender',
          multi: true,
          options: [
            {
              label: 'Male',
              value: 1,
              selected: false
            },
            {
              label: 'Female',
              value: 2,
              selected: false
            },
            {
              label: 'Other',
              value: 3,
              selected: false
            }
          ]
        },
        {
          label: 'Income',
          code: 'income',
          multi: true,
          options: [
            {
              label: '$20,000-$49,999',
              value: 1,
              selected: false
            },
            {
              label: '$50,000-$99,999',
              value: 2,
              selected: false
            },
            {
              label: '$100,000-$149,999',
              value: 3,
              selected: false
            },
            {
              label: '$150,000-$249,999',
              value: 4,
              selected: false
            },
            {
              label: '$250,000+',
              value: 5,
              selected: false
            }
          ]
        },
        // {
        //   label: '12 Mo Intender',
        //   excludeFromVerbatims: true,
        //   code: 'auto_intender',
        //   multi: true,
        //   options: [
        //     {
        //       label: '12 Month Auto Intender',
        //       value: 1,
        //       selected: false
        //     },
        //     {
        //       label: 'Not a 12 Month Auto Intender',
        //       value: 2,
        //       selected: false
        //     }
        //   ]
        // },
        {
          label: 'Alt Fuel',
          excludeFromVerbatims: true,
          code: 'alt_fuel',
          multi: true,
          options: [
            {
              label: 'Alt Fuel Considerer',
              value: 1,
              selected: false
            },
            {
              label: 'Alt Fuel Rejector',
              value: 2,
              selected: false
            }
          ]
        },
        {
          label: 'Ethnicity',
          code: 'ethnicity',
          multi: true,
          options: [
            {
              label: 'White',
              value: 1,
              selected: false
            },
            {
              label: 'Black',
              value: 2,
              selected: false
            },
            {
              label: 'Latino',
              value: 3,
              selected: false
            },
            {
              label: 'Asian',
              value: 4,
              selected: false
            },
            {
              label: 'American Indian',
              value: 5,
              selected: false
            },
            {
              label: 'Middle Eastern/North African',
              value: 6,
              selected: false
            },
            {
              label: 'Hawaiian/Pacific Islander',
              value: 7,
              selected: false
            },
            {
              label: 'Other',
              value: 8,
              selected: false
            }
          ]
        }
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/components/scorecard/ScorecardView/ScorecardFilter/index.js